import { ChainId, Token } from 'sdk'
import { serializeToken } from 'state/user/hooks/helpers'
import { MAIN_CURRENCY } from './links'
import { SerializedToken } from './types'

const { MAINNET, TESTNET } = ChainId

interface TokenList {
  [symbol: string]: Token
}

interface SerializedTokenList {
  [symbol: string]: SerializedToken
}

export const mainnetTokens = {
  weth: new Token(
    MAINNET,
    '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    18,
    `W${MAIN_CURRENCY}`,
    `Wrapped ${MAIN_CURRENCY}`,
    'https://ethereum.com/',
  ),
  // eth here points to the weth contract. Wherever the currency ETH is required, conditional checks for the symbol 'ETH' can be used
  eth: new Token(
    MAINNET,
    '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    18,
    MAIN_CURRENCY,
    MAIN_CURRENCY,
    'https://ethereum.com/',
  ),
  cake: new Token(MAINNET, '0xB8c77482e45F1F44dE1745F52C74426C631bDD52', 18, 'BNB', 'BNB', 'https://eth.ncx.cx/'),
  usdt: new Token(MAINNET, '0xdAC17F958D2ee523a2206206994597C13D831ec7', 6, 'USDT', 'Tether USD', 'https://tether.to/'),
  usdc: new Token(MAINNET, '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', 6, 'USDC', 'USD Coin', 'https://cronos.org/'),
  dai: new Token(
    MAINNET,
    '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    18,
    'DAI',
    'Dai Stablecoin',
    'https://www.makerdao.com/',
  ),
  wbtc: new Token(
    MAINNET,
    '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    8,
    'WBTC',
    'Wrapped BTC',
    'https://cronos.org/',
  ),
  link: new Token(
    MAINNET,
    '0x514910771AF9Ca656af840dff83E8264EcF986CA',
    18,
    'LINK',
    'ChainLink Token',
    'https://cronos.org/',
  ),
  syrup: new Token(
    MAINNET,
    '0x3f767183E3DFf6726950965EBDE537C5a7C29595',
    18,
    'SYRUP',
    'SyrupBar Token',
    'https://eth.hopswap.finance/',
  ),
}

export const testnetTokens = {
  weth: new Token(
    TESTNET,
    '0x094616F0BdFB0b526bD735Bf66Eca0Ad254ca81F',
    18,
    `W${MAIN_CURRENCY}`,
    `Wrapped ${MAIN_CURRENCY}`,
    'https://ethereum.com/',
  ),
  cake: new Token(
    TESTNET,
    '0xa35062141Fa33BCA92Ce69FeD37D0E8908868AAe',
    18,
    'NCXX',
    'NCX Swap Token',
    'https://eth.ncx.cx/',
  ),
  usdc: new Token(
    TESTNET,
    '0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee',
    18,
    'BUSD',
    'Binance USD',
    'https://www.paxos.com/usdc/',
  ),
  syrup: new Token(
    TESTNET,
    '0xfE1e507CeB712BDe086f3579d2c03248b2dB77f9',
    18,
    'SYRUP',
    'SyrupBar Token',
    'https://eth.ncx.cx/',
  ),
  bake: new Token(
    TESTNET,
    '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
    18,
    'BAKE',
    'Bakeryswap Token',
    'https://www.bakeryswap.org/',
  ),
}

const tokens = (): TokenList => {
  const chainId = process.env.REACT_APP_CHAIN_ID

  // If testnet - return list comprised of testnetTokens wherever they exist, and mainnetTokens where they don't
  if (parseInt(chainId, 10) === ChainId.TESTNET) {
    return Object.keys(mainnetTokens).reduce((accum, key) => {
      return { ...accum, [key]: testnetTokens[key] || mainnetTokens[key] }
    }, {})
  }

  return mainnetTokens
}

export const serializeTokens = (): SerializedTokenList => {
  const unserializedTokens = tokens()
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [key]: serializeToken(unserializedTokens[key]) }
  }, {})

  return serializedTokens
}

export default tokens()
